<div class="task-details">
  <div class="flex-row-start-center gap-6">
    <input (change)="markTaskAsComplete($event, false)" [checked]="task.status === SubtaskStatus.Complete" [disabled]="task.status === SubtaskStatus.Complete" class="checkbox" type="checkbox" />
    <h2 class="task-details__heading" translate>{{ task.title }}</h2>
  </div>
  <div class="flex-row-start-center gap-6 mt-20">
    <app-icon color="var(--dark-charcoal)" iconName="clock"></app-icon>
    <p class="due-date" translate>Due Date</p>
    <p class="due-date">:- {{ task?.date | date: 'dd.MM.yyyy' }}</p>
  </div>
  <p [innerHTML]="task.description" class="task-details__text">{{ task.description }}</p>

  <h2 class="heading mt-30" translate>Participants</h2>

  @if (!isLoading) {
    <div class="rows-columns mt-20">
      @for (participant of users; track participant) {
        <div class="flex-row-between-center">
          <div class="flex-row-start-center">
            <div class="task-details__wrapper background-loading-tiny">
              <img [appFetchProfileImage]="participant?.memberId" alt="" lazy="true" loading="lazy" src="assets/images/placeholder.png" />
            </div>
            <div class="ml-10">
              <h4 class="task-details__name">{{ participant?.fullName }}</h4>
              <p class="task-details__role" translate>{{ participant?.email }}</p>
            </div>
          </div>
          <div>
            <app-badge fontSize="10px" text="Pending"></app-badge>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="rows-columns">
      @for (_ of [].constructor(6); track _) {
        <ngx-skeleton-loader
          [count]="1"
          [theme]="{
            height: '80px',
            width: '100%',
            borderRadius: '10px',
          }"
        ></ngx-skeleton-loader>
      }
    </div>
  }
</div>
